var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMPermisos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#2eccb6;}.cls-3{fill:#329be6;mix-blend-mode:multiply;}.cls-4{fill:#0b5c96;}.cls-5{fill:#fff;}.cls-6{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m_permisos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2_Permisos",
    "data-name": "2 Permisos"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.28,32.72a.4.4,0,0,0,0,.56L11.75,44.75V21.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20,14.24h6V19H40V14.24h6L46,19h6L33.28.28a.4.4,0,0,0-.56,0L14,19h6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.72,65.72a.4.4,0,0,0,.56,0l14-14-28.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.72,32.72,54.25,21.25v23.5L65.72,33.28A.4.4,0,0,0,65.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.15,19a.4.4,0,0,0-.4.4v1.88L14,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.25,19.35a.4.4,0,0,0-.4-.4H52l2.3,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.25,49.26v-2l-2.5-2.5v6.61a.4.4,0,0,0,.4.4h6.61l-2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.75,49.24h-2l-2.5,2.5h6.59a.4.4,0,0,0,.4-.4V44.75l-2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52,19H46l0-4.31a.4.4,0,0,0-.4-.4H40.4a.4.4,0,0,0-.4.4V19H26V14.64a.4.4,0,0,0-.4-.4H20.41a.4.4,0,0,0-.4.4V19H14l-2.28,2.28v23.5l2.5,2.5v-19l37.5,0v19l2.5-2.5V21.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M14.25,28.23v21l37.5,0v-21Zm28.6,6.11L30.22,47a.4.4,0,0,1-.57,0l-6.5-6.5a.4.4,0,0,1,0-.56l2.27-2.27a.4.4,0,0,1,.56,0l3.95,4L40,31.51a.39.39,0,0,1,.56,0l2.27,2.26A.42.42,0,0,1,42.85,34.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M40.58,31.51a.39.39,0,0,0-.56,0L29.93,41.6l-3.95-4a.4.4,0,0,0-.56,0l-2.27,2.27a.4.4,0,0,0,0,.56l6.5,6.5a.4.4,0,0,0,.57,0L42.85,34.34a.42.42,0,0,0,0-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.58,31.51a.39.39,0,0,0-.56,0L29.93,41.6l-3.95-4a.4.4,0,0,0-.56,0l-2.27,2.27a.4.4,0,0,0,0,.56l6.5,6.5a.4.4,0,0,0,.57,0L42.85,34.34a.42.42,0,0,0,0-.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "16.26 49.26 18.76 51.76 47.26 51.74 49.76 49.24 16.26 49.26"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 66,
    height: 66
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMPermisos);
export default __webpack_public_path__ + "static/media/m_permisos.578b65bd109a57052c59da78e29f4dc0.svg";
export { ForwardRef as ReactComponent };